export default __webpack_public_path__ + "static/media/brand-arrow.0504b8be.svg";